// Cloudinary URL builders.
// Reads cloud name + root folder from environment.
// Public IDs may be passed with or without the root folder prefix.

const CLOUD_NAME = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME || "";
const ROOT_FOLDER =
  process.env.REACT_APP_CLOUDINARY_FOLDER || "Peak-Adventures-Malnad";

export const isCloudinaryEnabled = () => Boolean(CLOUD_NAME);
export const cloudinaryCloudName = CLOUD_NAME;
export const cloudinaryRootFolder = ROOT_FOLDER;

function resolveId(publicId) {
  if (!publicId) return null;
  const p = String(publicId).replace(/^\/+/, "");
  return p.startsWith(`${ROOT_FOLDER}/`) ? p : `${ROOT_FOLDER}/${p}`;
}

function baseUrl(kind) {
  return `https://res.cloudinary.com/${CLOUD_NAME}/${kind}/upload`;
}

/**
 * Build a Cloudinary image URL for a given public ID.
 * @param {string} publicId  e.g. "rooms/couple" (root folder auto-prepended)
 * @param {object} opts { width, height, quality, format, crop, gravity }
 * @returns {string|null} URL or null if Cloudinary is not configured / no id
 */
export function cldImage(publicId, opts = {}) {
  if (!isCloudinaryEnabled() || !publicId) return null;
  const {
    width,
    height,
    quality = "auto",
    format = "auto",
    crop = "fill",
    gravity = "auto",
  } = opts;
  const t = [`f_${format}`, `q_${quality}`];
  if (width) t.push(`w_${width}`);
  if (height) t.push(`h_${height}`);
  if (width || height) t.push(`c_${crop}`, `g_${gravity}`);
  return `${baseUrl("image")}/${t.join(",")}/${resolveId(publicId)}`;
}

/** Tiny blurred placeholder for LQIP */
export function cldBlur(publicId) {
  if (!isCloudinaryEnabled() || !publicId) return null;
  return `${baseUrl("image")}/w_30,e_blur:1200,q_auto,f_auto/${resolveId(publicId)}`;
}

/** Responsive srcset string */
export function cldSrcSet(publicId, opts = {}) {
  if (!isCloudinaryEnabled() || !publicId) return null;
  const widths = opts.widths || [400, 640, 800, 1200, 1600, 2000, 2400];
  return widths
    .map((w) => `${cldImage(publicId, { ...opts, width: w })} ${w}w`)
    .join(", ");
}

/**
 * Cloudinary video URL. Accepts either bare id ("hero/drone-view") or ".mp4"
 */
export function cldVideo(publicId, opts = {}) {
  if (!isCloudinaryEnabled() || !publicId) return null;
  const { quality = "auto", format = "auto" } = opts;
  const t = [`f_${format}`, `q_${quality}`].join(",");
  return `${baseUrl("video")}/${t}/${resolveId(publicId)}`;
}

/** Video poster (first-second frame extract) as jpg */
export function cldVideoPoster(publicId) {
  if (!isCloudinaryEnabled() || !publicId) return null;
  return `${baseUrl("video")}/so_1,f_jpg,q_auto,w_1920/${resolveId(publicId)}.jpg`;
}
